import styled from "styled-components";
export const PolicyContainer = styled.div`
    padding: 32px 0;
`